<div
    class="navbar-scroll-container h-full"
    fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
>
    <div class="navbar-content h-full flex flex-col">
        <fuse-navigation layout="vertical"></fuse-navigation>
    </div>
</div>
